/**
 * SpinnerIcon/index.js
 * desc: content spinner icon (includes animation)
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';
import './styles.css';


const SpinnerIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="spinner icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.spinner.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19"><path d="M5.19 0A10.001 10.001 0 0 0 10 18.768 10.001 10.001 0 0 0 14.81 0l-1.588 3.707A6 6 0 1 1 4 8.768a6 6 0 0 1 2.779-5.06L5.189 0Z"/></svg>
    </IconButton>
);


export default SpinnerIcon;
